import { styled } from '@linaria/react'
import { PosterSC } from 'atoms/ImagePoster'
import { COLOR, FIXED_INDENTS } from 'vars/index'

const LOGO_SIZE = 86

/**
 * `Channel logo container` from the banner-description concept: the channel
 * logo contained in a round chip that shrinks to the logo plus its paddings.
 */
export const BannerLogoSC = styled.div`
  box-sizing: content-box;
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  /* TextBlock's Wrapper sizes its first child with a nth-child rule that
   * outranks this class and resets the width to auto. The clamp keeps the chip
   * square, so the 50% radius stays a circle instead of shrink-wrapping the
   * logo into an ellipse. */
  width: ${LOGO_SIZE}px;
  min-width: ${LOGO_SIZE}px;
  max-width: ${LOGO_SIZE}px;
  height: ${LOGO_SIZE}px;
  padding: var(${FIXED_INDENTS.INDENT_30});
  border-radius: 50%;
  background: var(${COLOR.SURFACE_OPACITY_LIGHT_20});

  & ${PosterSC} {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

/** WBS badges and shorts above the banner title — one row, 8px gap (Figma labels). */
export const BannerTopLabelsSC = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_20});
`
